module.exports = __webpack_public_path__ + "static/img/onboarding_team_skip_modal.2a7732a3.png";